import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { PageHeader } from '../../components/PageHeader';

const PRODUCT_NAV = [
  { to: '/products', label: 'รายการสินค้า' },
  { to: '/categories', label: 'หมวดหมู่' },
  { to: '/pricing', label: 'ราคาแยกสาขา' },
] as const;

export type ProductStatusTone = 'ok' | 'warn' | 'danger' | 'neutral';

export function ProductHeader({
  title,
  subtitle,
  actions,
  status,
  nav = true,
}: {
  title: ReactNode;
  subtitle: ReactNode;
  actions?: ReactNode;
  status?: { label: string; tone: ProductStatusTone };
  /** Section tabs; off on form pages where switching sections loses edits. */
  nav?: boolean;
}) {
  return (
    <div className={nav ? 'mb-6' : undefined}>
      <PageHeader
        title={title}
        subtitle={subtitle}
        actions={actions}
        status={status}
      />
      {nav && (
        <nav
          aria-label="เมนูศูนย์ข้อมูลสินค้า"
          className="flex flex-wrap gap-1 border-b border-line"
        >
          {PRODUCT_NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `min-h-11 shrink-0 border-b-2 px-3 py-2 text-center text-sm-label font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-ink ${
                  isActive
                    ? 'border-primary text-primary'
                    : 'border-transparent text-ink-2 hover:bg-bg-warm hover:text-ink'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      )}
    </div>
  );
}
